// TopProfileDialog.tsx — Top edge / parapet profile (tpvar)

import { useState } from 'react';
import DialogBase from './DialogBase';
import { useShallowStore } from '../store/useStore';
import type { TpVar } from '../types/panelvar';

export default function TopProfileDialog() {
  const { ui, project, updatePanel } = useShallowStore(s => ({
    ui: s.ui, project: s.project, updatePanel: s.updatePanel,
  }));
  const panel = project?.panels.find(p => p.id === ui.activePanelId);
  const [tp, setTp] = useState<TpVar>(panel ? { ...panel.tpvar } : { enabled: false, thickness: 0.5, width: 6, material: 'steel', mark: 'TP-1' });
  if (!panel) return null;

  function set(key: keyof TpVar, value: string | number | boolean) {
    setTp(prev => ({ ...prev, [key]: value }));
  }

  const numericFields: (keyof TpVar)[] = ['thickness', 'width'];

  return (
    <DialogBase title="Top Profile" onOk={() => updatePanel(panel.id, { tpvar: tp })}>
      <div className="dialog-section">
        <div className="dialog-row">
          <label className="dialog-label">Enabled</label>
          <input
            type="checkbox"
            checked={tp.enabled}
            onChange={e => set('enabled', e.target.checked)}
          />
        </div>
        <div className="dialog-row">
          <label className="dialog-label">Mark</label>
          <input
            className="dialog-input sm"
            type="text"
            value={tp.mark}
            onChange={e => set('mark', e.target.value)}
          />
        </div>
        <div className="dialog-row">
          <label className="dialog-label">Material</label>
          <input
            className="dialog-input sm"
            type="text"
            value={tp.material}
            onChange={e => set('material', e.target.value)}
          />
        </div>
        {numericFields.map(key => (
          <div className="dialog-row" key={key as string}>
            <label className="dialog-label">{String(key)}</label>
            <input
              className="dialog-input sm"
              type="number"
              value={tp[key] as number}
              step={0.25}
              onChange={e => set(key, parseFloat(e.target.value))}
            />
            <span className="dialog-unit">"</span>
          </div>
        ))}
      </div>
    </DialogBase>
  );
}

